import React from "react";
import StepZilla from "react-stepzilla";
import '../styles/step.css';
import Step from './Steps';
export default class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.genControls= this.genControls.bind(this);
        this.onStepChange=this.onStepChange.bind(this);
       
      //  this.onChange=this.onChange.bind(this);
        this.state = {
           items:this.props.datasource!=null?this.props.datasource:[],
           steps: [
            {name: 'Step 1', component: <div>1</div>},
            {name: 'Step 2', component: <div>2</div>},
            {name: 'Step 3', component:<div>3</div>},
            {name: 'Step 4', component: <div>4</div>},
            {name: 'Step 5', component: <div>5</div>},
            {name: 'Step 6', component:<div>6</div>},
            {name: 'Step 7', component: <div>7</div>},
            {name: 'Step 8', component: <div>8</div>},
            {name: 'Step 9', component: <div>9</div>}
          ]
        };
    }
componentDidMount(){
    this.genControls();
  
    
}

componentDidUpdate(){
   
}
onStepChange(step){
    // console.log(step);
  
    // if(this.state.items.length-1 == step){
       
    // }
}
genControls(){
    
    var arr=[];
    this.state.items.forEach((a,index) => {
        if(a.tipo === 'Combo'){
            let itm={
                name:"Pregunta "+(index+1),
                component:<Step type={a.tipo} id={"prg"+index} opciones={a.options} label={a.pregunta}  onChange={this.props.onChange} />//<select className="frm" name={"prg"+index} id= >{this.llenarCombo()}</select>
            }
            arr.push(itm);
        }
        if(a.tipo === 'Check'){
         let itm={
             name:"Pregunta "+(index+1),
             component:<Step type={a.tipo} id={"prg"+index} label={a.pregunta} />  //<label className="switch"><input type="checkbox" name={"prg"+index}id={"prg"+index}/><span className="slider round" /> </label>
         }
         arr.push(itm);
        }
    });
    this.setState({steps:arr});
 
}

render(){
    const steps =this.state.steps;
   
    return(
        <div className=''>
            <div className='step-progress' style={{width:'100%'}}>
                <StepZilla steps={steps} 
                showNavigation={true}
                showSteps={true}
                stepsNavigation={true}
                nextButtonText={'Siguiente'}
                backButtonText={ "Atrás"}
                onStepChange={e=> this.onStepChange(e)}
                startAtStep={0}
                dontValidate={false}
               // hocValidationAppliedTo={ [1, 2]}
                nextButtonCls={"btn2 btn-prev btn-info btn-lg"}
                backButtonCls={"btn2 btn-next btn-info btn-lg float-left"}
                />
            </div>
        </div>
    );
}
}